import { useNavigate } from 'react-router-dom';
import { useGeoLocation } from '../contexts/GeoLocationContext';

export const useStateAwareNavigation = () => {
  const navigate = useNavigate();
  const { location } = useGeoLocation();

  const navigateToBill = (billSlug: string) => {
    // Convert state name to URL-friendly format
    if (location?.state) {
      const stateName = location.state
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9-]/g, '');

      navigate(`/bill/${stateName}/${billSlug}`);
    } else {
      // No location available, default to Texas (founder's state)
      navigate(`/bill/texas/${billSlug}`);
    }
  };

  const getBillUrl = (billSlug: string) => {
    // Convert state name to URL-friendly format
    if (location?.state) {
      const stateName = location.state
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9-]/g, '');

      return `/bill/${stateName}/${billSlug}`;
    } else {
      // No location available, default to Texas (founder's state)
      return `/bill/texas/${billSlug}`;
    }
  };

  return { navigateToBill, getBillUrl };
};
